export const state = {
  slotId: "",
  patientId: "",
  complaintDescription: "",
  chiefComplaint: "",
  visitDate: null,
  height: "",
  weight: "",
  isSmoking: false,
  allergies: [],
  confirmedAccurace: false,
  medications: [],
  pmh: [],
  session: {
    id: "",
    status: "",
    rejectDate: "",
    price: "$0",
  },
  reassign: false,
  reassignPractitionerId: "",
};
